import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import { fetchAdminExperts, verifyExpert } from '../../api/admin';
import { AdminDataTable, AdminPagination, Column } from '../../components/admin';

const AdminExperts: React.FC = () => {
  const colors = useAppSelector((state) => state.theme.theme);
  const navigate = useNavigate();
  const [experts, setExperts] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const pageSize = 20;

  const load = useCallback(() => {
    setLoading(true);
    fetchAdminExperts({ page, page_size: pageSize })
      .then((res) => { setExperts(res.data.results); setTotal(res.data.total); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [page]);

  useEffect(() => { load(); }, [load]);

  const handleVerify = async (userId: number, current: boolean) => {
    try {
      await verifyExpert(userId, !current);
      load();
    } catch {}
  };

  const columns: Column[] = [
    { key: 'user_id', header: 'ID', width: '60px' },
    { key: 'name', header: 'Name' },
    { key: 'email', header: 'Email' },
    { key: 'sebi_reg_number', header: 'SEBI #', render: (row) => row.sebi_reg_number || '-' },
    { key: 'total_completed_sessions', header: 'Sessions', width: '80px' },
    {
      key: 'user_avg_rating', header: 'Rating', width: '80px',
      render: (row) => row.user_avg_rating?.toFixed(1) || '0.0',
    },
    {
      key: 'is_verified', header: 'Verified', width: '100px',
      render: (row) => (
        <button
          onClick={(e) => { e.stopPropagation(); handleVerify(row.user_id, row.is_verified); }}
          className="px-2 py-0.5 rounded-full text-xs font-medium"
          style={{
            backgroundColor: row.is_verified ? '#10B98120' : '#EF444420',
            color: row.is_verified ? '#10B981' : '#EF4444',
          }}
        >
          {row.is_verified ? 'Verified' : 'Unverified'}
        </button>
      ),
    },
  ];

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold mb-6" style={{ color: colors.textColor }}>Expert Management</h1>

      <AdminDataTable
        columns={columns}
        data={experts}
        loading={loading}
        onRowClick={(row) => navigate(`/admin/users/${row.user_id}`)}
        emptyMessage="No experts found"
      />
      <AdminPagination page={page} totalPages={Math.ceil(total / pageSize)} onPageChange={setPage} />
    </div>
  );
};

export default AdminExperts;
